import { types } from '../constants'

const index = {
  addProduct: types.product.add,
  deleteProduct: types.product.remove,
  deleteAllProducts: types.product.remove_all,
  addProductsBulkPending: `${types.product.addBulk}_PENDING`,
  addProductsBulkFulfilled: `${types.product.addBulk}_FULFILLED`,
  addProductsBulkRejected: `${types.product.addBulk}_REJECTED`
}

const reducerKey = 'products'

export const handleProducts: ActionProps = {
  [index.addProduct]: ({ draft, action }) => {
    const product = action.payload

    const oldSelectedProducts =
      draft.industry.campaign[reducerKey].selectedProducts

    draft.industry.campaign[reducerKey].selectedProducts = [
      product,
      ...oldSelectedProducts
    ]
  },
  [index.deleteProduct]: ({ draft, action }) => {
    const oldSelectedProducts =
      draft.industry.campaign[reducerKey].selectedProducts
    const removeId = action.payload.id

    const removeSku = action.payload.product_sku

    const filteredProducts = oldSelectedProducts.filter(item =>
      item.id ? item.id !== removeId : item.product_sku !== removeSku
    )

    draft.industry.campaign[reducerKey].selectedProducts = filteredProducts
  },
  [index.deleteAllProducts]: ({ draft, action }) => {
    const isEdit = action.payload
    const oldSelectedProducts =
      draft.industry.campaign[reducerKey].selectedProducts

    if (!isEdit) {
      draft.industry.campaign[reducerKey].selectedProducts = []
    } else {
      const products = oldSelectedProducts.filter(
        item => item.item_disabled === true
      )

      draft.industry.campaign[reducerKey].selectedProducts = products
    }
  },
  //
  [index.addProductsBulkPending]: ({ draft }) => {
    draft.industry.campaign[reducerKey].loadingAddBulk = true
    draft.industry.campaign[reducerKey].rejectedProducts = null
  },
  //
  [index.addProductsBulkFulfilled]: ({ draft, action }) => {
    const oldSelectedProducts =
      draft.industry.campaign[reducerKey].selectedProducts

    const addedProducts = action.payload.data

    const findIndexOffer = offer =>
      oldSelectedProducts.findIndex(item =>
        offer.id ? offer.id === item.id : offer.product_sku === item.product_sku
      )

    const selectedOffers = addedProducts.filter(
      item => findIndexOffer(item) === -1
    )

    // Handle rejected products
    const allRequestedProductSkus = action.values.product_skus

    const rejectedProducts = allRequestedProductSkus.filter(
      item =>
        !(
          addedProducts.findIndex(
            offer => offer.product_sku === item || offer.id === item
          ) > -1
        )
    )

    draft.industry.campaign[reducerKey].selectedProducts = [
      ...selectedOffers,
      ...oldSelectedProducts
    ]

    draft.industry.campaign[reducerKey].rejectedProducts = rejectedProducts

    draft.industry.campaign[reducerKey].loadingAddBulk = false
  },
  [index.addProductsBulkRejected]: ({ draft }) => {
    draft.industry.campaign[reducerKey].loadingAddBulk = false
  }
}
